import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useWaterConsumptionReport(data, options, key = "WaterConsumption") {
  const axiosPrivate = useAxiosPrivate();

  const getWaterConsumptionReport = async () => {
    const events = await axiosPrivate({
      method: "POST",
      url: "/Reports/WaterConsumption",
      data,
    }).then((res) => res.data);
    return events;
  };

  return useQuery([key, data], () => getWaterConsumptionReport(data), {
    ...options,
  });
}

export default useWaterConsumptionReport;
